import styled from 'styled-components';
import { spaceFlowContainer } from 'src/utilities/UIStyles/variables/spacing';
import {
  whiteSphera,
  blackSphera,
  greenSp,
  grayLight
} from 'src/utilities/UIStyles/variables/Colors';

export const ThreatContainer = styled.section`
  display: flex;
  flex-wrap: wrap;

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const TextContainer = styled.div`
  width: 100%;
  text-align: center;
  justify-content: center;
  margin: 5% 0;
  > h2 {
    font-size: 1.5rem;
  }
  > p {
    font-size: 1.2rem;
    margin: 2%;
    > a {
      color: ${greenSp};
      font-size: 1.2rem;
      font-weight: bold;
    }
  }
`;

export const Banner = styled.div`
  display: flex;
  align-items: center;
  /* background-color: ${whiteSphera}; */
  background-color: ${grayLight};
  padding: 5%;
  text-align: center;
  ${spaceFlowContainer(true)}

  > figure {
    width: 85px;
    height: 85px;
    margin-right: 5%;

    > img {
      width: 100%;
      height: auto;
    }
  }

  > h2 {
    color: ${blackSphera};
    font-size: 3vw;
    width: 100%;
  }

  > p {
    color: ${blackSphera};
    font-size: 1.5vw;
    width: 45%;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    justify-content: center;
    padding: 25% 0 2.5% 0%;

    > figure {
      margin-right: 0;
      margin-bottom: 5%;

      > img {
      }
    }

    > h2 {
      font-size: 6vw;
      width: 100%;
      margin-right: 0;
      margin-bottom: 2%;
      text-align: center;
    }

    > p {
      text-align: center;
      font-size: 4vw;
      width: 90%;
      margin-bottom: 5%;
    }
  }
`;
